import { render, staticRenderFns } from "./TheStandImageIcon.vue?vue&type=template&id=de39e9a8&"
import script from "./TheStandImageIcon.vue?vue&type=script&lang=js&"
export * from "./TheStandImageIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports